<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg">
        <img src="assets/svg/contract-icon.svg" alt="icono contrato" />
      </div>
      <div>
        <h4 class="text-semibold">Nuevo contrato</h4>
        <h6 class="color-gray">
          Agrega los detalles para registrar un nuevo contrato.
        </h6>
      </div>
      <div>
        <img
          (click)="closeMdl()"
          class="close-button"
          src="assets/svg/close-icon.svg"
          alt="cerrar"
        />
      </div>
    </div>

    <div class="mdl-body">
      <h5 class="text-semibold mt-4">Información del contrato</h5>
      <form #ContractForm="ngForm" (ngSubmit)="$event.preventDefault()">
      <div
        class="d-grid prospect-form"
        style="grid-template-columns: 1fr 1fr; column-gap: 32px"
      >
        <div class="fila-1">
          <div class="mt-3">
            <label class="login-label">Número del contrato:</label>
            <input
              class="crm-input"
              type="text"
              name="numero_contrato"
              [(ngModel)]="request.numero_contrato"
              readonly
            />
          </div>
          <div class="mt-3">
            <label class="login-label">Orden de compra:</label>
            <input class="crm-input" type="text" name="orden_compra" [(ngModel)]="request.orden_compra" placeholder="OC-12345">
          </div>
          

          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.fecha_inicio || request.fecha_inicio.trim()===''">*</span>
              Fecha de inicio:
            </label>
            <input
              class="crm-input"
              type="date"
              [(ngModel)]="request.fecha_inicio"
              placeholder="Selecciona"
              name="fecha_inicio"
              required
              #fechaInicio="ngModel"
            />
            <div class="error-text" *ngIf="fechaInicio.invalid && (fechaInicio.dirty || fechaInicio.touched)">
              <small *ngIf="fechaInicio.errors?.['required']">
                El campo Fecha de inicio es obligatorio
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!selectedRecordatorio">*</span>
              Aviso de vencimiento:
            </label>
            <select
              class="crm-input"
              name="aviso_vencimiento"
              [(ngModel)]="selectedRecordatorio"
              (change)="onRecordatorioChange()"
              required
              #recordatorioCtrl="ngModel"
            >
              <option value="" disabled selected hidden>Selecciona aviso de vencimiento</option>

              <option [ngValue]="null">Selecciona aviso de vencimiento</option>
              <option [ngValue]="{ valor: 7, unidad: 'dias' }">
                7 días antes
              </option>
              <option [ngValue]="{ valor: 15, unidad: 'dias' }">
                15 días antes
              </option>
              <option [ngValue]="{ valor: 30, unidad: 'dias' }">
                30 días antes
              </option>
              <option [ngValue]="{ valor: 2, unidad: 'meses' }">
                2 meses antes
              </option>
              <option [ngValue]="{ valor: 3, unidad: 'meses' }">
                3 meses antes
              </option>
              <option [ngValue]="{ valor: 6, unidad: 'meses' }">
                6 meses antes
              </option>
              <option [ngValue]="{ valor: 12, unidad: 'meses' }">
                12 meses antes
              </option>
            </select>
            <div class="error-text" *ngIf="recordatorioCtrl.invalid && recordatorioCtrl.touched">
              <small *ngIf="recordatorioCtrl.errors?.['required']">
                El aviso de vencimiento es obligatorio
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk" *ngIf="!request.tipo || request.tipo.trim()===''">*</span>
               Tipo de contrato:
              </label>
            <select class="crm-input" [(ngModel)]="request.tipo" name="tipo" required #tipoCtrl="ngModel">
              <option value="" disabled selected hidden>Tipo de contrato</option>
              <option value="Servicio">Servicio</option>
              <option value="Suscripción de software">Suscripción de software</option>
              <option value="Soporte">Soporte</option>
              <option value="Arriendo de equipamiento hardware">Arriendo de equipamiento hardware</option>
              <option value="Arriendo de software">Arriendo de software</option>
              <option value="Arriendo de equipamiento ">Arriendo de equipamiento </option>
              <option value="Consultoría">Consultoría</option>
            </select>
            <div class="error-text" *ngIf="tipoCtrl.invalid && tipoCtrl.touched">
              <small *ngIf="tipoCtrl.errors?.['required']">
                El tipo de contrato es obligatorio
              </small>

            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Monto acordado total:</label>
            <input
              class="crm-input"
              type="number"
              name="monto"
              min="0"
              [(ngModel)]="request.monto"
              (input)="calcularMontoMensual()"
              placeholder="Ingrese monto"
            />
          </div>

          <div class="mt-3">
            <label class="login-label">Moneda:</label>
            <select class="crm-input" [(ngModel)]="request.moneda" name="moneda">
              <option value="" disabled selected hidden>Selecciona el tipo de moneda</option>

              <option value="CLP">CLP - Peso chileno</option>
              <option value="USD">USD - Dólar estadounidense</option>
            </select>
          </div>
        </div>

        <div class="fila-2">
            <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk"
                    *ngIf="!request.archivo_url">*</span>
              Adjuntar archivo:
            </label>

            <label for="fileInput" class="custom-file-upload">
              <img src="assets/svg/upload-icon.svg" alt="subir" width="18" class="me-2" />
              Adjuntar archivo
            </label>

            <input
              id="fileInput"
              type="file"
              name="archivo"
              (change)="onFileSelected($event); archivoTouched = true"
              class="hidden-file-input"
            />

            <div *ngIf="request.archivo_url" class="file-name">
              {{ request.archivo_url }}
            </div>

            <div class="error-text" *ngIf="!request.archivo_url && archivoTouched">
              <small>El archivo adjunto es obligatorio</small>
            </div>
          </div>


          <div class="mt-3">
            <label class="login-label">
              <span class="required-asterisk"
                    *ngIf="!request.duracion_meses">*</span>
              Duración del contrato (meses):
            </label>
            <input
              class="crm-input"
              type="number"
              min="1"
              name="duracion_meses"
              [(ngModel)]="request.duracion_meses"
              (input)="calcularMontoMensual()"
              placeholder="Indica la cantidad de meses en números"
              required
              #duracionCtrl="ngModel"
            />
            <div class="error-text" *ngIf="duracionCtrl.invalid && duracionCtrl.touched">
              <small *ngIf="duracionCtrl.errors?.['required']">
                La duración del contrato es obligatoria
              </small>
              <small *ngIf="duracionCtrl.errors?.['min']">
                La duración mínima es de 1 mes
              </small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label"><span class="required-asterisk" *ngIf="!request.oportunidad_id || request.oportunidad_id.trim()===''">*</span>Oportunidad vinculada:</label>
            <div style="border: solid 1px #d9d9d9; padding: 0px 10px">
              <div class="d-grid crm-ng-select">
                <div>
                  <img
                    class="dropdown-icon"
                    src="assets/svg/opportunities-icon.svg"
                    alt="icono-estrella"
                  />
                </div>
                <ng-select
                  class="crm-ng-select"
                  *ngIf="oportunidades"
                  [items]="oportunidades"
                  bindLabel="nombre"
                  name="oportunidad"
                  bindValue="oportunidad_id"
                  placeholder="Buscar oportunidad..."
                  [(ngModel)]="request.oportunidad_id"
                  [searchable]="true"
                  [clearable]="true"
                >
                </ng-select>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label">Estado:</label>
            <select class="crm-input" [(ngModel)]="request.estado" name="estado"> >
            <option value="" disabled selected hidden>Selecciona el estado del contrato</option>
              <option value="Borrador">Borrador</option>
              <option value="En proceso de aprobación">
                En proceso de aprobación
              </option>
              <option value="Activado">Activado</option>
            </select>
          </div>

          <div class="mt-3">
            <label class="login-label">Monto mensual:</label>
            <input
              class="crm-input"
              type="number"
              [(ngModel)]="request.monto_mensual"
              readonly
              name="monto_mensual"
            />
          </div>
        </div>
      </div>
      <div class="mt-3">
        <label class="login-label">Comentario / Notas:</label>
        <textarea
          class="crm-input"
          placeholder="Agrega observaciones para este contrato (opcional)"
          rows="3"
          [(ngModel)]="request.observaciones"
          style="height: 98px; resize: none"
          name="observaciones"
        >
        </textarea>
      </div>
    
      <hr class="mt-5 mb-5" />

  <div class="d-flex flex-row justify-center gap-20 mt-2">
    <button type="button" (click)="closeMdl()" class="btn btn-primary-outline">
      Cancelar
    </button>

    @if (data.mode === 'edit') {
    <button type="button" class="btn btn-primary text-center" (click)="updateContract()" [disabled]="!ContractForm.valid">
      Modificar contrato
    </button>
    } @else {
    <button type="button" class="btn btn-primary text-center" (click)="createContract()" [disabled]="!ContractForm.valid">
      Crear nuevo contrato
    </button>
    }
  </div>
  </form>
  </div>
</div>
